// src/index.js
import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import keycloak from './keycloak';

const Index = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authInitialized, setAuthInitialized] = useState(false);

  const handleAuthentication = useCallback((authenticated) => {
    setIsAuthenticated(authenticated);
    setAuthInitialized(true);

    if (authenticated) {
      console.log('Usuario autenticado:', keycloak.tokenParsed?.preferred_username);
      keycloak.onTokenExpired = handleTokenExpiration;
    } else {
      console.log('Usuario no autenticado');
      keycloak.login();
    }
  }, []);

  const handleTokenExpiration = () => {
    console.log('Token expirado, actualizando...');
    keycloak.updateToken(30).catch(() => {
      console.error('No se pudo actualizar el token');
    });
  };

  useEffect(() => {
    const initKeycloak = async () => {
      try {
        const initOptions = getKeycloakInitOptions();
        const authenticated = await keycloak.init(initOptions);
        handleAuthentication(authenticated);
      } catch (error) {
        console.error('Error al inicializar Keycloak:', error);
        setAuthInitialized(true);
      }
    };

    initKeycloak();
  }, [handleAuthentication]);

  const getKeycloakInitOptions = () => {
    return {
      checkLoginIframe: false,
      pkceMethod: 'S256',
      enableLogging: true,
      silentCheckSsoFallback: false,
      flow: 'standard'
    };
  };

  if (!authInitialized) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Inicializando autenticación...</p>
      </div>
    );
  }

  return <App keycloak={keycloak} isAuthenticated={isAuthenticated} />;
};

// Si estás usando React 18, debes usar createRoot en lugar de ReactDOM.render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>
);